export const getFlash = state =>
  (state.flash ? Object.assign({}, state.flash) : null);
export const getFlashMessage = state =>
  (state && state.message);
export const getFlashShow = state =>
  (state && state.show);
export const getFlashType = state =>
  (state && state.type);
export const getFlashDuration = state =>
  (state && state.autHideDuration);



// WEBPACK FOOTER //
// ./src/redux/flash/selectors.js